
const pro = {
    url: {
        API_URL: 'https://admin.nvdsmarthome.com'
    }
};

const dev = {
    url: {
        API_URL: 'http://58.137.160.78:3000'
        // API_URL: 'http://127.0.0.1:3000'
    }
};

export const config = dev ;